export const HE_PLACES_AUTOCOMPLETE_URL = 'https://healthengine.com.au/api/4/places/autocomplete';

export const REQUEST_APPOINTMENT_URL = '/api/4/braze/practice/request-appointment';

export const PRACTICE_APPOINTMENTS_URL = '/public/practice/appointments.php';

export const CHEMIST2U_API_URL = 'https://gateway.chemist2u.com.au/api';
